import { render, staticRenderFns } from "./CandleChartContainer.vue?vue&type=template&id=076bba22&scoped=true&"
import script from "./CandleChartContainer.vue?vue&type=script&lang=ts&"
export * from "./CandleChartContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076bba22",
  null
  
)

export default component.exports